module.exports = {"en":{"process_manager_error_client_closed":"Client assigned to {username} has closed unexpectedly."},"de":{"process_manager_error_client_closed":"Der {username} zugewiesene Client wurde unerwartet beendet."},"fr":{"process_manager_error_client_closed":"Le client pour {username} s’est fermé inopinément."},"ru":{"process_manager_error_client_closed":"Клиент, связанный с учётной записью {username} внезапно закрылся."},"zh":{"process_manager_error_client_closed":"以{username}登陆的客户端意外关闭了。"}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Backend/localization/localized.json
// module id = 904
// module chunks = 0